export const BLOG_DATA = [
  { image: "2", hits: "0", date: "02" },
  { image: "3", hits: "02", date: "03" },
];

export const BLOG_DATAS = ["blog-5.jpg", "blog-6.jpg", "blog-5.jpg", "blog-6.jpg"];

export const RADIO_DATAS = [
  {
    text: "Text",
  },
  {
    text: "Image",
  },
  {
    text: "Audio",
    defaultChecked: true,
  },
  {
    text: "Video",
  },
];

export const POST_TYPE_DATA = [{ name: "Lifestyle" }, { name: "Travel" }];
